import React, {useEffect, useRef, useState} from 'react';
import PopupSelectAdapter from "../PopupSelectAdapter";
import PropTypes from "prop-types";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import PopupOptions from "../popup_select_component/PopupOptions";
import LinkForPopup from './link_implement/AreasPopupLinkForArticles';
import {fetchPopupData} from "../popup_select_component/fetchPopupData";
import PopupSelect from "../PopupSelect";
import ReactDOM from "react-dom";

const AreasRegistratorForWorkArticles = props => {
  const [areaIds, setAreaIds] = useState(props.area_ids || "");

  const url = (() => {
    const path = '/popup/member_areas';
    const data = {
      selected_ids: areaIds.split(","),
      is_limited_item: 0
    };
    return path + '?' + (new URLSearchParams(data)).toString();
  })();

  const onClosePopup = selectedAreaTypes => {
    setAreaIds(selectedAreaTypes.map(area => area.id).join(','));
  };

  const onChangeAreaIds = event => {
    setAreaIds(event.target.value);
  };

  return (
    <>
      <PopupSelectAdapter
        popupOptions={PopupOptions.areas}
        fetchedData={fetchPopupData(url)}
        needSelectedAllButton={true}
        rootNode={document.querySelector('#popup_member_areas')}
        onClosePopup={onClosePopup}
        selectedNames={props.input_area_name}
        LinkForPopup={LinkForPopup}
        ButtonArea={ButtonArea}

      />
      <input type="hidden"
             name="work_article[work_article_areas_ids]"
             onChange={onChangeAreaIds}
             value={areaIds}
      />
    </>
  );
};

AreasRegistratorForWorkArticles.propTypes = {
  area_ids: PropTypes.string,  // ie. "1,2,3"
  input_area_name: PropTypes.string  // ie. "name1/name2/name3"
};

const ButtonArea = props => {
  return <a className="select select-area-btn" onClick={props.onClickCloseButton}>選択</a>
};

export default AreasRegistratorForWorkArticles;
